import {gql} from '@apollo/client'

export const createApplication = gql `
  mutation createApplication ($input: ApplicationRequest!) {
      createApplication (input: $input) {
        name
        email
      }
}
`